import { timeout } from "./utils";
export function initTurnstile() {
    // @ts-ignore
    window.turnstileCompleted = turnstileCompleted;
    // @ts-ignore
    window.turnstileExpired = turnstileExpired;
    // @ts-ignore
    window.turnstilePromiseResolver = () => { };
    // @ts-ignore
    window.turnstileLoadStartTime = new Date().getTime();
    // @ts-ignore
    window.turnstilePromise = new Promise((resolve) => {
        // @ts-ignore
        window.turnstilePromiseResolver = resolve;
    });
}
export function resetTurnstile() {
    turnstile.reset();
    resetTurnstilePromise();
}
function resetTurnstilePromise() {
    // @ts-ignore
    window.turnstileLoadStartTime = new Date().getTime();
    // @ts-ignore
    window.turnstilePromise = new Promise((resolve) => {
        // @ts-ignore
        window.turnstilePromiseResolver = resolve;
    });
}
function completeTurnstilePromise() {
    // @ts-ignore
    const turnstileDuration = new Date().getTime() - window.turnstileLoadStartTime;
    // @ts-ignore
    window.turnstilePromiseResolver();
    console.log(`Turnstile check completed in ${turnstileDuration} ms`);
    // Let's send an appInsights metric for the duration it took to finish the turnstile check
    // @ts-ignore
    appInsights.trackMetric({ name: "TurnstileDurationV2", average: turnstileDuration, sampleCount: 1 });
}
export function turnstileCompleted(token) {
    if (token !== "") {
        // Resolve the turnstile promise to indicate completion
        completeTurnstilePromise();
        const turnstileWidget = document.getRequiredHtmlElementById("turnstileWidget");
        // Set the token attribute on the turnstile widget
        turnstileWidget.dataset.token = token;
    }
}
export function turnstileExpired() {
    resetTurnstilePromise();
}
export function getTurnstilePromise() {
    // @ts-ignore
    return window.turnstilePromise;
}
export async function waitForTurnstilePromiseOrTimeout(timeoutInMs) {
    await timeout(getTurnstilePromise(), timeoutInMs);
}
